import apiClient from "./apiClient";
import {setAlert} from "./alert";
import {USER_LOADED, AUTH_ERROR, LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT, RESET_ALL_STATES} from "./types";
import {Role, Server, User} from "@leap4/auth";
import {Dispatch} from "redux";
import {History} from "history";
import {AlertTypes} from "../utils/alert.utils";
import {BACKEND_SERVICE_NAME, baseBackendRoute,meMultiUrl} from "../config/generals";



export const loadUser = async (dispatch: Dispatch<any>) => {
    try {
        // const meMultiPath = baseBackendRoute+meMultiUrl
        const res = await apiClient.get(Server.routes.USERS.ME.path);
        const user: User = User.init(res.data);


        if (!user.hasPermission([Role.ADMIN], BACKEND_SERVICE_NAME)) {
            throw new Error(`This pannel accessible only for user with ${Role.ADMIN} permission.`)
        }

        dispatch({
            type: USER_LOADED,
            payload: user,
        });
    } catch (err) {
        dispatch({
            type: AUTH_ERROR,
        });
        dispatch(setAlert(err.message, AlertTypes.FAILURE))
    }
};

export const login = (email: string, password: string) => async (dispatch: Dispatch<any>) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const body = JSON.stringify({email, password});

    try {
        await apiClient.post(Server.routes.USERS.LOGIN.path, body, config);
        const resMe = await apiClient.get(Server.routes.USERS.ME.path)
        const user = User.init(resMe.data);

        if (!user.hasPermission([Role.ADMIN], 'auth-server')) {
            throw new Error(`This panel accessible only for user with ${Role.ADMIN} permission.`)
        }

        dispatch({
            type: USER_LOADED,
            payload: user,
        });
        dispatch({
            type: LOGIN_SUCCESS,
        });

        dispatch(setAlert(`Login successfully`, AlertTypes.SUCCESS));
    } catch (err) {
        dispatch({
            type: LOGIN_FAIL,
        });
        dispatch(setAlert(err.message, AlertTypes.FAILURE))
    }
};

// Logout - clears auth user from state and removes the auth-token cookie(Security).
export const logout = async (dispatch: Dispatch<any>, history: History) => {
    try {
        // API call to logout route, to receive empty "auth-token" cookie with expression date of now(for auto remove the cookie by the browser).
        await apiClient.get(Server.routes.USERS.LOGOUT.path);

        dispatch({type: LOGOUT});
        dispatch({type: RESET_ALL_STATES});
        dispatch(setAlert("Logout successfully!", AlertTypes.SUCCESS));

        // Redirect to landing page.
        history.push("/");
    } catch (err) {
        dispatch({
            type: AUTH_ERROR,
        });
    }
};
